export const LocalStorageKeys = {
  ROOSTER_REFERRAL: 'rooster-referral',
  ROOSTER_RMCLID: 'rooster-rmclid',
};
